import React, { useState } from 'react';

const Flisearbejde = () => {
  const [lightboxImage, setLightboxImage] = useState(null);

  const tileImages = [
    '/media/billeder/Fliser/IMG_0047.jpeg',
    '/media/billeder/Fliser/IMG_0049.jpeg',
    '/media/billeder/Fliser/IMG_0054.jpeg',
    '/media/billeder/Fliser/IMG_2281.jpeg',
  ];

  const bathroomImages = [
    '/media/billeder/Badeværelse/IMG_2645.jpeg',
    '/media/billeder/Badeværelse/IMG_2644.jpeg',
    '/media/billeder/Badeværelse/IMG_2638.jpeg',
    '/media/billeder/Badeværelse/IMG_1380.jpeg',
    '/media/billeder/Badeværelse/IMG_0285.jpeg',
    '/media/billeder/Badeværelse/IMG_0284.jpeg',
    '/media/billeder/Badeværelse/IMG_0096.jpeg',
    '/media/billeder/Badeværelse/IMG_0093.jpeg',
  ];

  const openLightbox = (image) => {
    setLightboxImage(image);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };

  return (
    <div className="pt-20 bg-gray-100">
      {/* Tiles Section */}
      <section className="min-h-screen flex flex-col lg:flex-row">
        <div className="lg:w-1/3 bg-gradient-to-br from-primary to-secondary text-white p-12 flex items-center justify-center">
          <div className="text-center text-shadow-strong">
            <h1 className="text-5xl font-bold mb-6">FLISER</h1>
            <p className="text-xl">Professionelt flisearbejde med fokus på detaljer</p>
          </div>
        </div>

        <div className="lg:w-2/3 p-8 lg:p-16">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {tileImages.map((img, idx) => (
              <div 
                key={idx}
                onClick={() => openLightbox(img)}
                className="relative group cursor-pointer overflow-hidden rounded-lg shadow-xl transform hover:-translate-y-2 transition-all duration-300"
              >
                <img 
                  src={img} 
                  alt={`Fliser ${idx + 1}`}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300 flex items-center justify-center">
                  <span className="text-white text-lg font-bold opacity-0 group-hover:opacity-100 transition-opacity">
                    Klik for at forstørre
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bathrooms Section */}
      <section className="min-h-screen flex flex-col lg:flex-row-reverse bg-white">
        <div className="lg:w-1/3 bg-gradient-to-br from-dark to-primary text-white p-12 flex items-center justify-center">
          <div className="text-center text-shadow-strong">
            <h2 className="text-5xl font-bold mb-6">BADEVÆRELSER</h2>
            <p className="text-xl">Renovering og nybyg med høj kvalitet</p>
          </div>
        </div>

        <div className="lg:w-2/3 p-8 lg:p-16 bg-gray-50">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {bathroomImages.map((img, idx) => (
              <div 
                key={idx}
                onClick={() => openLightbox(img)}
                className="relative group cursor-pointer overflow-hidden rounded-lg shadow-xl transform hover:-translate-y-2 transition-all duration-300"
              >
                <img 
                  src={img} 
                  alt={`Badeværelse ${idx + 1}`}
                  className="w-full h-48 object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300 flex items-center justify-center">
                  <span className="text-white text-sm font-bold opacity-0 group-hover:opacity-100 transition-opacity">
                    Klik for at forstørre
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxImage && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4 animate-fadeIn"
          onClick={closeLightbox}
        >
          <button 
            className="absolute top-8 right-8 text-white text-5xl hover:text-secondary transition-colors"
            onClick={closeLightbox}
          >
            &times;
          </button>
          <img 
            src={lightboxImage} 
            alt="Enlarged view"
            className="max-w-full max-h-[90vh] rounded-lg shadow-2xl"
          />
        </div>
      )}
    </div>
  );
};

export default Flisearbejde;
